/**
 * Created by sairam on 14/04/17.
 */
import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    REGISTER_REQUESTED,
    REGISTER_SUCCESSFUL,
    REGISTER_FAILED,
} from './RegisterActionTypes';


import {
    LOGIN_REQUESTED,
    LOGIN_SUCCESSFUL,
    LOGIN_FAILED,
} from './../Login/LoginActionTypes';

export const initialState = Map({
  session: {},
  user: {},
  error: {},
  errorMessage: '',
  isLoading: false,
  registered: false,
});

const handlers = {
  [REGISTER_REQUESTED](state) {
    return state.merge({
      isLoginRequested: true,
      isLoading: true,
      errorMessage: '',
    });
  },
  [REGISTER_FAILED](state, action) {
    return state.merge({
      isLoginRequested: false,
      isLoading: false,
      error: action.error,
      errorMessage: action.error.message,
    });
  },
  [REGISTER_SUCCESSFUL](state, action) {
    return state.merge({
      session: action.session,
      user: action.user,
      registered: true,
      isLoading: false,
      errorMessage: '',
    });
  },
  [LOGIN_REQUESTED](state) {
    return state.merge({
      isLoginRequested: true,
      isLoading: true,
      errorMessage: '',
    });
  },
  [LOGIN_SUCCESSFUL](state, action) {
    return state.merge({
      session: action.session,
      user: action.user,
      isLoading: false,
      errorMessage: ',',
    });
  },
  [LOGIN_FAILED](state, action) {
    return state.merge({
      isLoginRequested: false,
      isLoading: false,
      error: action.error,
      errorMessage: 'Incorrect username and password.',
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      session: {},
      user: {},
      error: {},
      isLoading: false,
      registered: false,
      errorMessage: '',
    });
  },
};

export const register = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.register.get('error');
const getSession = state => state.register.get('session');
const getUser = state => state.register.get('user');
const getIsLoading = state => state.register.get('isLoading');
const getRegistered = state => state.register.get('registered');
const errorMessage = state => state.register.get('errorMessage');

export const registerSelector = createStructuredSelector({
  error: getError,
  session: getSession,
  user: getUser,
  isLoading: getIsLoading,
  registered: getRegistered,
  errorMessage,
});



// WEBPACK FOOTER //
// ./src/containers/Register/Register.redux.js